import { render } from "./AboutUsSection.vue?vue&type=template&id=1e1f4371&scoped=true&bindings={}"
import script from "./AboutUsSection.vue?vue&type=script&lang=ts"
export * from "./AboutUsSection.vue?vue&type=script&lang=ts"

import "./AboutUsSection.vue?vue&type=style&index=0&id=1e1f4371&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1e1f4371"

export default script